// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import CampaignAllocationController from "./campaign_allocation_controller"
application.register("campaign-allocation", CampaignAllocationController)

import CampaignAutocompleteController from "./campaign_autocomplete_controller"
application.register("campaign-autocomplete", CampaignAutocompleteController)

import SystemAutocompleteController from "./system_autocomplete_controller"
application.register("system-autocomplete", SystemAutocompleteController)

import DashboardRefreshController from "./dashboard_refresh_controller"
application.register("dashboard-refresh", DashboardRefreshController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)
